// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".btnBox {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 30px;\n}\n.el-table--border {\n  border: 1px solid #f5f5f5 !important;\n  border-bottom: 1px solid #f5f5f5 !important;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
